export default function Guest ({ next }){
    return window.user ? next({ name: 'class.dashboard' }) : next();
}
